import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

function PartnerManagement() {
  const [partners, setPartners] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [earnings, setEarnings] = useState([]);
  const [tab, setTab] = useState('partners');
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [pRes, aRes, eRes] = await Promise.all([
        apiFetch(`${API_BASE_URL}/admin/partners`),
        apiFetch(`${API_BASE_URL}/admin/partners/assignments`),
        apiFetch(`${API_BASE_URL}/admin/partners/earnings`),
      ]);
      const pJson = await pRes.json();
      const aJson = await aRes.json();
      const eJson = await eRes.json();
      setPartners((pJson.data?.items) || []);
      setAssignments((aJson.data?.items) || []);
      setEarnings((eJson.data?.items) || []);
    } catch {
      // handled
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const tabs = [
    { key: 'partners', label: 'Partners' },
    { key: 'assignments', label: 'Assignments' },
    { key: 'earnings', label: 'Earnings' },
  ];

  return (
    <Layout>
      <h4 className="mb-4 fw-bold">Partner Management</h4>

      <ul className="nav nav-tabs mb-3">
        {tabs.map((t) => (
          <li className="nav-item" key={t.key}>
            <button
              className={`nav-link ${tab === t.key ? 'active' : ''}`}
              style={{ fontSize: '0.8125rem' }}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          </li>
        ))}
      </ul>

      {loading ? (
        <div className="text-center py-5">Loading...</div>
      ) : (
        <>
          {tab === 'partners' && (
            <div className="card">
              <div className="card-body p-0">
                <table className="table table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
                  <thead className="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partners.map((p) => (
                      <tr key={p.id}>
                        <td>{p.displayName}</td>
                        <td>{p.email}</td>
                        <td><span className="badge bg-primary">{p.role}</span></td>
                        <td>{new Date(p.createdAt).toLocaleDateString('ja-JP')}</td>
                      </tr>
                    ))}
                    {partners.length === 0 && (
                      <tr><td colSpan={4} className="text-center text-muted py-4">No partners yet</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 'assignments' && (
            <div className="card">
              <div className="card-body p-0">
                <table className="table table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
                  <thead className="table-light">
                    <tr>
                      <th>Partner ID</th>
                      <th>Prefecture</th>
                      <th>Status</th>
                      <th>Target</th>
                      <th>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignments.map((a) => (
                      <tr key={a.id}>
                        <td style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>{a.partnerId?.slice(0, 8)}...</td>
                        <td>{a.prefecture}</td>
                        <td><span className={`badge bg-${a.status === 'active' ? 'success' : 'secondary'}`}>{a.status}</span></td>
                        <td>{a.targetStores}</td>
                        <td>{a.completedStores}</td>
                      </tr>
                    ))}
                    {assignments.length === 0 && (
                      <tr><td colSpan={5} className="text-center text-muted py-4">No assignments yet</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {tab === 'earnings' && (
            <div className="card">
              <div className="card-body p-0">
                <table className="table table-sm mb-0" style={{ fontSize: '0.8125rem' }}>
                  <thead className="table-light">
                    <tr>
                      <th>Partner ID</th>
                      <th>Period</th>
                      <th>Scans</th>
                      <th>Stores</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {earnings.map((e) => (
                      <tr key={e.id}>
                        <td style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>{e.partnerId?.slice(0, 8)}...</td>
                        <td>{new Date(e.periodStart).toLocaleDateString('ja-JP')} - {new Date(e.periodEnd).toLocaleDateString('ja-JP')}</td>
                        <td>{e.scanCount}</td>
                        <td>{e.storeCount}</td>
                        <td>{'\u00a5'}{(e.amountYen || 0).toLocaleString()}</td>
                        <td><span className={`badge bg-${e.status === 'paid' ? 'success' : e.status === 'approved' ? 'info' : 'warning'}`}>{e.status}</span></td>
                      </tr>
                    ))}
                    {earnings.length === 0 && (
                      <tr><td colSpan={6} className="text-center text-muted py-4">No earnings yet</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </Layout>
  );
}

export default PartnerManagement;
